<script>
  import options from './SchemaMarkupDropdown.options'
  export default options
</script>

<template>
  <div class="kb-field">
    <label v-if="label" :for="fieldId" class="kb-field__label">{{ label }}</label>

    <select
      :id="fieldId"
      class="kb-field__input kb-field__select"
      :value="modelValue"
      :disabled="disabled"
      @change="onChange"
    >
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
  </div>
</template>
